/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCouch = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M4 2v6H2v6h1v6h2v2h2v-2h9v2h2v-2h3v-6h1V8h-2V2zm14 6h-3v6.5H9V8H6V4h12zM5 12H4v-2h3v6.5h10V10h3v2h-1v6H5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgCouch as Couch };
